<div
  class="fiscal-card"
  *ngIf="type == 'card'"
  [class.is-on]="taxRegisterConfigured && isFiscalCheck"
  [class.is-off]="taxRegisterConfigured && !isFiscalCheck"
  [class.is-disabled]="notConfigured || !taxRegisterConfigured"
>
  <ion-progress-bar *ngIf="loading" type="indeterminate"></ion-progress-bar>

  <div class="fiscal-card__row">
    <div class="fiscal-card__main">
      <ion-icon
        class="fiscal-card__icon"
        [name]="
          taxRegisterConfigured && isFiscalCheck
            ? 'checkmark-circle'
            : 'warning'
        "
        [color]="
          taxRegisterConfigured && isFiscalCheck ? 'success' : 'danger'
        "
      ></ion-icon>

      <div class="fiscal-card__copy">
        <div class="fiscal-card__title">
          <ng-container *ngIf="notConfigured">
            Програмний реєстратор вимкнено
          </ng-container>
          <ng-container *ngIf="!notConfigured && isFiscalCheck">
            Фіскальна операція
          </ng-container>
          <ng-container *ngIf="!notConfigured && !isFiscalCheck">
            Не фіскальна операція
          </ng-container>
        </div>

        <div
          class="fiscal-card__meta"
          *ngIf="taxRegisterConfigured && isFiscalCheck"
          (click)="toggleFiscalOperation()"
        >
          <span *ngIf="orgName">ФОП {{ orgName }}</span>
          <span *ngIf="registerLabel">{{ registerLabel }}</span>
          <span *ngIf="registerAddress">{{ registerAddress }}</span>
        </div>

        <div
          class="fiscal-card__hint"
          *ngIf="!taxRegisterConfigured || !isFiscalCheck"
        >
          РРО/ПРРО обов’язковий при розрахунках. Відповідальність за вимкнення
          фіскалізації несе користувач.
        </div>
      </div>
    </div>

    <div
      class="button-wrapper"
      *ngIf="taxRegisterConfigured"
      (click)="toggleFiscalOperation()"
    >
      <div class="button-cover"></div>
      <ion-button
        fill="outline"
        size="small"
        [disabled]="fiscalOperationInProgress"
        [color]="isFiscalCheck ? 'primary' : 'medium'"
      >
        <ion-spinner
          name="crescent"
          *ngIf="fiscalOperationInProgress"
        ></ion-spinner>
        <span>{{ isFiscalCheck ? 'Увімкнено' : 'Вимкнено' }}</span>
        <ion-toggle [checked]="isFiscalCheck"></ion-toggle>
      </ion-button>
    </div>
  </div>
</div>

<div
  class="button-wrapper is-standalone"
  *ngIf="taxRegisterConfigured && type == 'button'"
>
  <div class="button-cover" (click)="toggleFiscalOperation()"></div>
  <ion-button
    fill="outline"
    size="small"
    [disabled]="fiscalOperationInProgress"
    [color]="isFiscalCheck ? 'primary' : 'medium'"
  >
    <ion-spinner name="crescent" *ngIf="fiscalOperationInProgress"></ion-spinner>
    <span>{{ isFiscalCheck ? 'Увімкнено' : 'Вимкнено' }}</span>
    <ion-toggle [checked]="isFiscalCheck"></ion-toggle>
  </ion-button>
</div>
